import { render, staticRenderFns } from "./Emay.vue?vue&type=template&id=64440d8c&scoped=true&"
import script from "./Emay.vue?vue&type=script&lang=js&"
export * from "./Emay.vue?vue&type=script&lang=js&"
import style0 from "./Emay.vue?vue&type=style&index=0&id=64440d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64440d8c",
  null
  
)

export default component.exports